const Unsupported = ({ type }) => (
    <div className="p-3 text-danger">
        Unsupported file type: {type || "unknown"} – Please download to view.
    </div>
);

export { Unsupported };
